import { render, staticRenderFns } from "./ConfigurationField.vue?vue&type=template&id=386f4cda&scoped=true"
import script from "./ConfigurationField.vue?vue&type=script&lang=js"
export * from "./ConfigurationField.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationField.vue?vue&type=style&index=0&id=386f4cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f4cda",
  null
  
)

export default component.exports